import { PropsWithChildren } from "react";
import { resolveAssetUrl } from "../../../utils/resolveAssetUrl";

type ErrorPageProps = PropsWithChildren<{
  title: string;
  renderLogo?: boolean;
}>

const ErrorPage = ({ title, children, renderLogo }: ErrorPageProps) => {
  return (
    <div className="flex h-screen w-screen items-center flex-col justify-center p-6">
      <div className="flex flex-col gap-4 max-w-lg">
        <h1 className="text-5xl font-semibold leading-none text-center">{title}</h1>

        {children && (
          <div className="text-lg text-gray-500 text-center">
            {children}
          </div>
        )}

        {renderLogo && (
          <div className="flex items-center justify-center mt-12">
            <img className='w-32' src={resolveAssetUrl(undefined)}></img>
          </div>
        )}
      </div>
    </div>
  )
};

export default ErrorPage;
